/* eslint-disable */
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const TermsPagePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default TermsPagePropTypes;
